import { useState, useEffect } from   'react';
import { NavLink} from 'react-router-dom';
// removed react-data-table-component import — using native HTML table instead
import { useForm } from 'react-hook-form';
import apiService from '../../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip'; 
import { useAuth } from '../../../Auth/AuthContext';
import { FaEdit } from 'react-icons/fa';
import { ConvertErrors422ToString } from '../../Utils/ConvertErrors422ToString';

function EditarLineaAccion(row, Editar){
    return <div>
        <div className="btn-group">
            <button type="button" className="btn btn-info" onClick={() => Editar(row)} 
                data-tooltip-id='tooltiparriba'
                data-tooltip-content="Editar">
                    <FaEdit size={20} />
            </button>
        </div>
        
    </div>
}

export default function LineasAccion(){
    const {token} = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [datos, setDatos] = useState([]);
    const [lineasAccion, setLineasAccion] = useState([]);
    const { handleSubmit, register, setValue, formState: { errors }} = useForm();
    const [MuestraFormulario, setMuestraFormulario] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = async () => {
        const url = '/parametros/organizaciones/listarlineasaccion';
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
        setDatos(result);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    function Editar (row){
        setMuestraFormulario(true);
        setValue('id', row.id);
        setValue('linea', row.linea);
        setValue('estado', row.estado);
    };
    const Nuevo = () =>  {
        setValue('id', 0);
        setValue('linea', '');
        setValue('estado', false);
        setMuestraFormulario(true);
    }
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/parametros/organizaciones/guardarlineaaccion';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar', JSON.stringify(response.data));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar', ConvertErrors422ToString(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            fetchData();
            ResetForm();
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const ResetForm = () => {
        setValue('id', 0);
        setValue('linea', '');
        setValue('estado', false);
        setMuestraFormulario(false);
    }
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Líneas de Acción organizaciones</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={'/'} >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to={'/parametros'} >Par&aacute;metros</NavLink></li>
                        <li className="breadcrumb-item active"> Líneas de Acción organizaciones </li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    {MuestraFormulario && <div className="card card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario</h3>
                                
                            </div>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    
                                    <input hidden {...register('id')}/>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='linea'>Línea de Acción</label>
                                                <input {...register('linea', { required: true })} 
                                                    className="form-control" 
                                                    placeholder="Línea de Acción"
                                                    id='linea'/>
                                                {errors.linea && <p style={{color: 'red'}}>Digitar dato</p>}
                                            </div>  
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('estado')}
                                                    className="custom-control-input" id="SwitchEstado"/>
                                                <label className="custom-control-label" htmlFor="SwitchEstado">Estado</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className='row'>
                                        <div className='col-md-1'>
                                            <button type="submit" className="btn btn-info">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }   
                    <div className="card card">
                        <div className="card-body">
                            <div className="card-body table-responsive p-0">
                                <button type='button' className='form-control' onClick={Nuevo}>Nuevo</button>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th style={{ width: '7%' }}>Acciones</th>
                                                <th style={{ width: '10%' }}>Id</th>
                                                <th style={{ width: '25%' }}>Línea de Acción</th>
                                                <th style={{ width: '7%' }}>Estado</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Array.isArray(datos) && datos.length > 0 ? (
                                                datos.map((row) => (
                                                    <tr key={row.id ?? `${row.linea}-${Math.random()}`}>
                                                        <td>{EditarLineaAccion(row, Editar)}</td>
                                                        <td>{row.id}</td>
                                                        <td>{row.linea}</td>
                                                        <td>{row.estado ? 'Activo' : 'Inactivo'}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={4} className="text-center">No hay datos para mostrar</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}